import NavBar from "../components/NavBar";

const FoodySupportPage = ({ language, onLanguageChange, t }) => {
  const contactItems = t("foodySupport.contactDetails.details") || [];
  const issues = t("foodySupport.commonIssues.items") || [];

  return (
    <div className="page foody-page support-page" id="foody-support-top">
      <NavBar
        language={language}
        onLanguageChange={onLanguageChange}
        items={[{ href: "/apps/foody", label: t("foodySupport.back") }]}
      />

      <main className="foody-main">
        <section className="foody-hero support-hero">
          <div className="foody-hero-copy">
            <span className="support-pill">{t("foodySupport.badge")}</span>
            <h1>{t("foodySupport.hero.title")}</h1>
            <p>
              {t("foodySupport.hero.descPrefix")} <strong>Foody</strong>?{" "}
              {t("foodySupport.hero.descSuffix")}
            </p>
            <p className="support-muted">{t("foodySupport.hero.updatedAt")}</p>
          </div>
        </section>

        <section className="foody-section">
          <div className="foody-grid support-grid">
            <article className="foody-card">
              <h3>{t("foodySupport.contact.title")}</h3>
              <p>{t("foodySupport.contact.emailLabel")}</p>
              <p>
                <a href="mailto:support-foody@wodaslabs.com">
                  support-foody@wodaslabs.com
                </a>
              </p>
              <p className="support-muted">
                {t("foodySupport.contact.responseTime")}
              </p>
            </article>

            <article className="foody-card">
              <h3>{t("foodySupport.contactDetails.title")}</h3>
              <p>{t("foodySupport.contactDetails.subtitle")}</p>
              <ul className="support-list">
                {contactItems.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </article>

            <article className="foody-card">
              <h3>{t("foodySupport.commonIssues.title")}</h3>
              <ul className="support-list">
                {issues.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </article>

            <article className="foody-card">
              <h3>{t("foodySupport.links.title")}</h3>
              <p>
                <a href="https://wodaslabs.com">
                  {t("foodySupport.links.home")}
                </a>
              </p>
              <p>
                <a href="https://wodaslabs.com/apps/foody/static/privacy">
                  {t("foodySupport.links.privacy")}
                </a>
              </p>
              <p>
                <a href="https://wodaslabs.com/apps/foody/static/terms-and-conditions">
                  {t("foodySupport.links.terms")}
                </a>
              </p>
              <p>
                <a href="https://wodaslabs.com/apps/foody/static/cookie-policy">
                  {t("foodySupport.links.cookie")}
                </a>
              </p>
              <p>
                <a href="https://wodaslabs.com/apps/foody/static/delete-account">
                  {t("foodySupport.links.delete")}
                </a>
              </p>
            </article>
          </div>
        </section>

        <section className="foody-cta">
          <div>
            <h2>{t("foodySupport.footer.title")}</h2>
            <p>
              {t("foodySupport.footer.desc")}
              <br />
              <a href="mailto:support-foody@wodaslabs.com">
                support-foody@wodaslabs.com
              </a>
            </p>
          </div>
          <div className="store-badges foody-store-badges">
            <a
              className="btn primary"
              href="mailto:support-foody@wodaslabs.com"
            >
              {t("foodySupport.footer.emailButton")}
            </a>
          </div>
        </section>
      </main>
    </div>
  );
};

export default FoodySupportPage;
